import React, { useState, useEffect } from "react";
import { Modal } from "react-bootstrap";
import config from "../../Common/Configurations/APIConfig";
import apiService from "../../Common/Configurations/APIService";
import { useAuth } from "../../Common/Configurations/AuthContext";

const initialFieldValues = {
  fromOriginId: "00000000-0000-0000-0000-000000000000",
  fromOriginName: "",
  companyId: "",
  userId: "",
};

const FromOriginModal = ({ show, onHide, onOriginCreated, recordForEdit }) => {
  const { user } = useAuth();
  const [btnLoading, setBtnLoading] = useState(false);
  const [values, setValues] = useState(initialFieldValues);
  const [errors, setErrors] = useState({});

  useEffect(() => {
    if (show) {
      if (recordForEdit) {
        setValues(recordForEdit);
      } else {
        setValues({
          ...initialFieldValues,
          companyId: user?.cid || "",
          userId: user?.id || "",
        });
      }
    }
  }, [show, recordForEdit, user]);

  const validate = () => {
    let temp = {};
    temp.fromOriginName = values.fromOriginName.trim() !== "";
    setErrors(temp);
    return Object.values(temp).every((x) => x === true);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setValues({
      ...values,

      [name]: value.toUpperCase(),
    });
  };

  const resetAndHide = () => {
    setValues(initialFieldValues);
    setErrors({});
    onHide();
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (validate()) {
      setBtnLoading(true);
      try {
        const isNew =
          values.fromOriginId === "00000000-0000-0000-0000-000000000000";
        const payload = { ...values };

        if (isNew) {
          await apiService.create(config.CREATEORIGIN, payload);
        } else {
          await apiService.update(config.UPDATEORIGIN, payload);
        }

        if (onOriginCreated) {
          onOriginCreated(); // Notify parent to refresh its list
        }
        resetAndHide();
      } catch (error) {
        console.error("Failed to save origin:", error);
      } finally {
        setBtnLoading(false);
      }
    }
  };

  return (
    <Modal show={show} onHide={resetAndHide} centered>
      <Modal.Header closeButton>
        <Modal.Title>
          {values.fromOriginId === "00000000-0000-0000-0000-000000000000"
            ? "Add"
            : "Edit"}{" "}
          Origin
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <form onSubmit={handleSubmit} noValidate>
          <div className="mb-3">
            <label className="form-label">Origin Name</label>
            <input
              type="text"
              name="fromOriginName"
              value={values.fromOriginName}
              onChange={handleInputChange}
              className={`form-control ${
                errors.fromOriginName === false ? "is-invalid" : ""
              }`}
              placeholder="Enter origin name (e.g., MUMBAI, DELHI)"
              maxLength={45}
            />
            {errors.fromOriginName === false && (
              <div className="invalid-feedback">
                Please enter an origin name.
              </div>
            )}
          </div>

          <div className="d-flex justify-content-end gap-2 mt-4">
            <button
              type="button"
              className="btn btn-danger"
              onClick={resetAndHide}
            >
              Cancel
            </button>
            <button
              type="submit"
              className="btn btn-primary"
              disabled={btnLoading}
            >
              {btnLoading ? "Saving..." : "Save"}
            </button>
          </div>
        </form>
      </Modal.Body>
    </Modal>
  );
};

export default FromOriginModal;
